/**
 * Utility to manually check user role from tai-khoan service
 * Run in browser console: window.checkMyRole()
 */

// Function to force refresh user role in the app
window.forceRefreshRole = () => {
  console.log('🔄 Forcing user role refresh...');
  // Clear the hasLoadedUser flag by reloading the page
  window.location.reload();
};

window.checkMyRole = async () => {
  console.log('🔍 Checking user role from tai-khoan service...');
  
  const token = localStorage.getItem('access_token');
  if (!token) {
    console.error('❌ No access token found. Please log in first.');
    return;
  }
  
  // Get current user from Auth0
  const auth0Cache = Object.keys(localStorage).find(key => key.includes('@@auth0spajs@@') && key.includes('@@user@@'));
  let currentUser = null;
  
  if (auth0Cache) {
    try {
      const cacheData = JSON.parse(localStorage.getItem(auth0Cache));
      currentUser = cacheData?.body?.decodedToken?.user || cacheData?.body?.user;
    } catch (e) {
      console.error('Could not parse Auth0 cache');
    }
  }
  
  if (!currentUser) {
    console.error('❌ Could not find current user info');
    return;
  }
  
  console.log('📤 Calling tai-khoan with:', {
    user_id: currentUser.sub,
    user_email: currentUser.email,
    user_name: currentUser.name || currentUser.nickname
  });
  
  try {
    const url = new URL('http://64.225.20.106:8081/getuser');
    url.searchParams.append('user_id', currentUser.sub);
    url.searchParams.append('user_name', currentUser.name || currentUser.nickname || '');
    url.searchParams.append('user_email', currentUser.email || '');
    
    console.log('🌐 Fetching from:', url.toString());
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      mode: 'cors'
    });
    
    if (!response.ok) {
      console.error(`❌ HTTP ${response.status} error from tai-khoan`);
      const text = await response.text();
      console.error('Response:', text);
      return;
    }
    
    const userData = await response.json();
    console.log('✅ Tai-khoan response:', userData);
    console.log('🎯 Your role is:', userData.user_role || 'Not set');
    console.log('📋 Full user data:', {
      id: userData.id,
      email: userData.email,
      role: userData.user_role,
      plan_status: userData.plan_status,
      plan_id: userData.plan_id,
      test_account: userData.test_account
    });
    
    return userData;
  } catch (error) {
    console.error('❌ Error calling tai-khoan:', error);
  }
};

// Function to manually set role (for testing)
window.setMyRole = (role) => {
  console.log(`🎯 Manually setting role to: ${role}`);
  
  // Find and update UserContext through React DevTools if available
  const event = new CustomEvent('setUserRole', { detail: { role } });
  window.dispatchEvent(event);
  
  console.log(`✅ Role set to ${role}. You may need to refresh for full effect.`);
};

console.log('💡 User role utilities loaded:');
console.log('  - window.checkMyRole() - Check your role from tai-khoan');
console.log('  - window.forceRefreshRole() - Force reload to refresh role');
console.log('  - window.setMyRole("Admin") - Manually set role for testing');

export default window.checkMyRole;